module.exports = __webpack_public_path__ + "img/restore_icon.0ad7fc94.svg";